import { render, staticRenderFns } from "./ProgramOfStudy.vue?vue&type=template&id=e5f0f684&scoped=true&lang=pug&"
import script from "./ProgramOfStudy.vue?vue&type=script&lang=js&"
export * from "./ProgramOfStudy.vue?vue&type=script&lang=js&"
import style0 from "./ProgramOfStudy.vue?vue&type=style&index=0&id=e5f0f684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f0f684",
  null
  
)

export default component.exports